import { ChangeEvent } from "react";
import { ClinicSetting } from "../../models";
import { ClinicSettingsTable } from "./ClinicSettingsTable";

interface ClinicSettingsSectionProps {
	title: string;
	settings?: ClinicSetting[];
	errors?: string[];
	onSettingChange: (event: ChangeEvent<HTMLInputElement>) => Promise<void>;
	onWaitTimeGroupChange: (
		event: ChangeEvent<HTMLInputElement>
	) => Promise<void>;
}

export const ClinicSettingsSection = ({
	title,
	settings,
	errors,
	onSettingChange,
	onWaitTimeGroupChange
}: ClinicSettingsSectionProps) => {
	if (!settings || settings.length === 0) {
		return <p>No settings available for {title}.</p>;
	}

	return (
		<section className="flex flex-col gap-4">
			<ClinicSettingsTable
				settings={settings}
				errors={errors}
				onSettingChange={onSettingChange}
				onWaitTimeGroupChange={onWaitTimeGroupChange}
			/>
		</section>
	);
};
